/**
 * webview 通信
 * 使用说明：jsbridge.callHandler('/methodName', { data: 123 }, (data) => {})
 */
import {IFunction, IJsbridge} from '../../typings';

// 简单原理流程说明:
// 前端调用接口:
// step1: 拼接请求链接.  jsbridge://method?cb=callback
// step2: 注册一个回调函数 jsbridge['callback'] = (data) => { 回调处理 }
// step3: 客户端接收 jsbridge://method?cb=callback， 处理并执行方法  webview.window.DJsbridge['callback'](data)
// step4: 前端回调 jsbridge['callback'] 被执行
// ---------------
// 客户端调用前端:（同上2和3）：
// step1: 前端注册一个函数 jsbridge['callback'] = (data) => { 回调处理 }
// step2: 客户端处理并执行方法  webview.window.DJsbridge['callback'](data)

import { EventEmitter } from 'events';
function genSeq(url: string): string {
  // 将请求名添加后缀，做为回调方法名，确保每次调用都是唯一的
  return url + parseInt(Math.random().toString().slice(2, 7) + Date.now() % 100000, 10);
}

const init = ()=>{
  window.jsbridge = {};
}

class Frame implements IJsbridge {
  private event = new EventEmitter();

  public registerHandler(name: string, fn: IFunction) {
    // 注册一个事件，可被客户端通过bridge直接调用
    if (!window.jsbridge[name]) {
      this.register(name); // 如果已经被注册，无须重复注册，但事件仍要绑定
    }
    this.event.on(name, fn);
  }

  public callHandler(protocol: string, params?: any) {
    // 调用接口
    return new Promise((resolve, reject) => {
      try {
        let url = 'jsbridge://' + protocol + '?';
        const unique = genSeq(protocol);

        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            // @zenny 2019-11-04
            // 拼接成 URL 的时候需要提前对值 encode，再由客户端 decode，避免解析出错的问题
            const value = encodeURIComponent(params[key]);
            url += `&${key}=${value}`;
          }
        }
        url += '&cb=' + unique; // 构建唯一的callback

        // 注册绑定回调函数
        this.register(unique);
        this.event.on(unique, (result: any) => {
          resolve(result);
          this.$off(unique);
        });
        this._call(url);
      } catch (e) {
        reject(e);
      }
    });
  }

  private _call(url: string) {
    // 利用iframe发出自定义请求，客户端对其拦截
    const iframe = document.createElement('IFRAME');
    iframe.setAttribute('src', url);
    document.body.appendChild(iframe);
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
  }

  private register(name: string) {
    // 利用iframe发出自定义请求，客户端对其拦截
    window.jsbridge[name] = (data: any) => {
      this.event.emit(name, data);
    };
  }

  private $off(name: string, func?: IFunction) {
    if (func) {
      this.event.removeListener(name, func);
    } else {
      this.event.removeAllListeners(name);
    }
    return this;
  }
}

export const getFrameJsbridge = ()=>{
    if(!window.jsbridge){
      init();
      window.jsbridge_frame_instance =  new Frame();
      return window.jsbridge_frame_instance as IJsbridge;
    }
    return window.jsbridge_frame_instance as IJsbridge;
}
